import React, { FC, ElementType } from "react";

// Define valid size keys
type SizeKey = "xs" | "s" | "md" | "lg" | "xl";

// Define the interface for the component's props
interface TextProps {
  children: React.ReactNode; // The content that goes inside the component
  className?: string; // Optional additional class names
  as?: ElementType; // The HTML or React element to render as
  size?: SizeKey; // Size key, defaults to 's'
  onClick?: () => void; // Optional click handler
}

// Define the size classes
const sizes: Record<SizeKey, string> = {
  xs: "text-xs font-normal",
  s: "text-sm font-medium",
  md: "text-base font-medium",
  lg: "text-lg font-medium",
  xl: "text-[19px] font-medium",
};

// Define the Text component
const Text: FC<TextProps> = ({
  children,
  className = "",
  as: Component = "p", // Default to 'p' if 'as' is not provided
  size = "s", // Default size
  onClick,
  ...restProps
}) => {
  return (
    <Component
      className={`text-gray-900_01 font-inter ${className} ${sizes[size]}`} // Combine classes
      onClick={onClick} 
      {...restProps} // Spread additional props
    >
      {children}
    </Component>
  );
};

export { Text };
